import { render, staticRenderFns } from "./svgTechnolife.vue?vue&type=template&id=ccb9f278"
import script from "./svgTechnolife.vue?vue&type=script&lang=js"
export * from "./svgTechnolife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports